import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
  actionIcon?: string;
}

export default function EmptyState({
  icon = "ri-emotion-sad-line",
  title,
  desc,
  actionLabel,
  onAction,
  actionTo,
  actionIcon = "ri-refresh-line",
}: EmptyStateProps) {
  const btnClass =
    "inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition hover:bg-primary-400";

  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-background-300 bg-background-50 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-3xl text-foreground-400">
        <i className={icon}></i>
      </span>
      <h3 className="mt-4 text-lg font-bold text-foreground-950">{title}</h3>
      {desc && <p className="mt-2 max-w-md px-4 text-sm text-foreground-600">{desc}</p>}
      {actionLabel && onAction && (
        <button type="button" onClick={onAction} className={`mt-5 ${btnClass}`}>
          <i className={actionIcon}></i>
          {actionLabel}
        </button>
      )}
      {actionLabel && !onAction && actionTo && (
        <Link to={actionTo} className={`mt-5 ${btnClass}`}>
          <i className={actionIcon}></i>
          {actionLabel}
        </Link>
      )}
    </div>
  );
}